import Form from '@admin/components/form'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Overview extends React.PureComponent {

  static contextTypes = {
    admin: PropTypes.object
  }

  static propTypes = {
    formdata: PropTypes.object,
    props: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: {}
  }

  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, disabled: true },
        { label: 't(Next)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            {
              label: 't(Terms and Conditions)',
              name: 'agreed_to_terms',
              type: 'termsfield',
              maxHeight: '430px',
              terms: (
                <>
                  <p><T text="t(I'm baby hell of green juice fixie chicharrones viral, coloring book tumblr blog artisan authentic vegan man bun mumblecore retro ascot. Offal jawn direct trade pinterest selvage retro you probably haven't heard of them authentic post-ironic. Shoreditch asymmetrical man braid everyday carry street art, kale chips 90's. Big mood fam yes plz vaporware neutral milk hotel, humblebrag meggings kitsch disrupt pinterest art party tonx. Franzen biodiesel cronut shoreditch, austin +1 tonx everyday carry chillwave blackbird spyplane hell of. JOMO pug unicorn enamel pin. Tilde tacos gorpcore, subway tile umami plaid sartorial pug trust fund raclette taxidermy.)" /></p>                
                  <p><T text="t(I'm baby hell of green juice fixie chicharrones viral, coloring book tumblr blog artisan authentic vegan man bun mumblecore retro ascot. Offal jawn direct trade pinterest selvage retro you probably haven't heard of them authentic post-ironic. Shoreditch asymmetrical man braid everyday carry street art, kale chips 90's. Big mood fam yes plz vaporware neutral milk hotel, humblebrag meggings kitsch disrupt pinterest art party tonx. Franzen biodiesel cronut shoreditch, austin +1 tonx everyday carry chillwave blackbird spyplane hell of. JOMO pug unicorn enamel pin. Tilde tacos gorpcore, subway tile umami plaid sartorial pug trust fund raclette taxidermy.)" /></p>                
                  <p><T text="t(I'm baby hell of green juice fixie chicharrones viral, coloring book tumblr blog artisan authentic vegan man bun mumblecore retro ascot. Offal jawn direct trade pinterest selvage retro you probably haven't heard of them authentic post-ironic. Shoreditch asymmetrical man braid everyday carry street art, kale chips 90's. Big mood fam yes plz vaporware neutral milk hotel, humblebrag meggings kitsch disrupt pinterest art party tonx. Franzen biodiesel cronut shoreditch, austin +1 tonx everyday carry chillwave blackbird spyplane hell of. JOMO pug unicorn enamel pin. Tilde tacos gorpcore, subway tile umami plaid sartorial pug trust fund raclette taxidermy.)" /></p>                
                  <p><T text="t(I'm baby hell of green juice fixie chicharrones viral, coloring book tumblr blog artisan authentic vegan man bun mumblecore retro ascot. Offal jawn direct trade pinterest selvage retro you probably haven't heard of them authentic post-ironic. Shoreditch asymmetrical man braid everyday carry street art, kale chips 90's. Big mood fam yes plz vaporware neutral milk hotel, humblebrag meggings kitsch disrupt pinterest art party tonx. Franzen biodiesel cronut shoreditch, austin +1 tonx everyday carry chillwave blackbird spyplane hell of. JOMO pug unicorn enamel pin. Tilde tacos gorpcore, subway tile umami plaid sartorial pug trust fund raclette taxidermy.)" /></p>                
                  <p><T text="t(I'm baby hell of green juice fixie chicharrones viral, coloring book tumblr blog artisan authentic vegan man bun mumblecore retro ascot. Offal jawn direct trade pinterest selvage retro you probably haven't heard of them authentic post-ironic. Shoreditch asymmetrical man braid everyday carry street art, kale chips 90's. Big mood fam yes plz vaporware neutral milk hotel, humblebrag meggings kitsch disrupt pinterest art party tonx. Franzen biodiesel cronut shoreditch, austin +1 tonx everyday carry chillwave blackbird spyplane hell of. JOMO pug unicorn enamel pin. Tilde tacos gorpcore, subway tile umami plaid sartorial pug trust fund raclette taxidermy.)" /></p>                
                </>
              ),
              prompt: 't(I agree to the terms and conditions)',
              required: true
            }
          ]
        }
      ]
    }
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(affiliate) {
    this.props.onNext(affiliate)
  }

}

export default Overview
